const GridIcon = ({
  className = "",
  color,
  secondaryColor,
}: {
  className?: string;
  color: string;
  secondaryColor?: string;
}) => (
  <svg
    className={className}
    aria-describedby="desc"
    aria-labelledby="title"
    role="img"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M2 2h12v12H2zm24 0h12v12H26zm24 0h12v12H50zM2 50h12v12H2z"
      data-name="layer2"
      fill="#4db9e8"
    />
    <path d="M26 50h12v12H26z" data-name="layer1" fill="#92d5b5" />
    <path d="M50 50h12v12H50z" data-name="layer3" fill="#f27e7c" />
    <path d="M2 25.988h12v12H2z" data-name="layer2" fill="#4db9e8" />
    <path
      d="M26 25.988h12v12H26zm24 0h12v12H50z"
      data-name="layer1"
      fill="#92d5b5"
    />
  </svg>
);

export default GridIcon;
